var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box d-print-noborder", class: _vm.borderCheck },
    [
      _c(
        "div",
        {
          staticClass: "level",
          class: { "is-marginless": _vm.moveChartIcons },
        },
        [
          _c("div", { staticClass: "level-left" }, [
            _vm.heading
              ? _c("h3", {
                  staticClass: "title is-4 has-text-weight-bold",
                  domProps: { textContent: _vm._s(_vm.heading) },
                })
              : _vm._e(),
          ]),
          _c("div", { staticClass: "level-right apex-download-options" }, [
            _vm.active
              ? _c(
                  "button",
                  {
                    staticClass:
                      "button is-small gtm-download-image level-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.saveChartImage.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("dc-icon", { attrs: { icon: "image-polaroid" } }),
                    _c("span", [_vm._v("Download image")]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showDownload
              ? _c(
                  "a",
                  {
                    staticClass:
                      "button is-small gtm-download-excel level-item",
                    attrs: { href: _vm.downloadURL, target: "_blank" },
                  },
                  [
                    _c("dc-icon", { attrs: { icon: "download" } }),
                    _c("span", [_vm._v(_vm._s(_vm.downloadLabel))]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm.active
        ? _c("vue-apex-charts", {
            ref: "apex-chart",
            class: [
              "apex-chart",
              { "move-burger": _vm.moveChartIcons },
              { "download-file": _vm.showDownload },
            ],
            attrs: {
              options: _vm.options,
              series: _vm.active && _vm.series,
              height: _vm.height,
              width: _vm.width,
            },
          })
        : _c(
            "div",
            [
              _vm.isFetching
                ? _c("dc-icon", { attrs: { icon: "sync", spin: "" } })
                : _c("span", [_vm._v("There is no data to display")]),
              _vm._v("  "),
              _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }